import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { Skeleton } from 'antd'

import { Button, Tooltip } from '../../../atoms'

import {
  convertToTagObject,
  placeholderHeadingOutline
} from './HeadingOutline.utils'
import styles from './HeadingOutline.module.css'

type Outline = {
  level: number
  text: string
}

interface Props {
  htmlJsonList?: Outline[]
  handleInsert?: (text: string) => void
}

export function HeadingOutline({ htmlJsonList, handleInsert }: Props) {
  if (!htmlJsonList) {
    return (
      <div>
        {getOutlineJSX(
          convertToTagObject(placeholderHeadingOutline),
          handleInsert
        )}
      </div>
    )
  }

  return (
    <div>{getOutlineJSX(convertToTagObject(htmlJsonList), handleInsert)}</div>
  )
}

const getOutlineJSX = (
  htmlJsonList: OutlineTagObject[],
  handleInsert?: (text: string) => void,

  indentationLevel = 0
) => {
  return htmlJsonList.map((tabObject, index) => {
    const innerJSX = getOutlineJSX(
      tabObject.child ?? [],
      handleInsert,
      indentationLevel + 1
    )
    return (
      <div
        className={clsx(
          {
            [styles.firstIndentLevel]: indentationLevel
          },
          index === 0 && indentationLevel === 0
            ? styles.zeroPaddingTop
            : styles.zeroIndentLevel
        )}
        key={`${indentationLevel}-${index}`}
      >
        <div className={styles.tagLine}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <div className={clsx(styles.tagContainer)}>{tabObject.tag}</div>
            <div className={styles.tagContent}>
              {tabObject.text ? (
                tabObject.text
              ) : (
                <Skeleton.Input
                  className={styles.tagContentSkeleton}
                  active={true}
                />
              )}
            </div>
          </div>
          {handleInsert && tabObject.text ? (
            <div className={styles.btnContainer}>
              <Tooltip title="Insert In Docs" placement="top">
                <Button
                  onClick={() =>
                    handleInsert(
                      `<${tabObject.tag}>${tabObject.text}</${tabObject.tag}>`
                    )
                  }
                  size="small"
                  icon={<Icon icon="uil:file-import" width={16} height={16} />}
                />
              </Tooltip>
            </div>
          ) : null}
        </div>

        {innerJSX}
      </div>
    )
  })
}
